import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const translateLanguageStep = defineStepConfig({
  type: "translate_language",
  name: "Translate Language",
  description: "Translate text from one language to another.",
  category: "AI & Agents",

  inputSchema: z.object({
    text: z.string().min(1).max(10000).describe("The text to translate."),
    targetLanguage: z
      .string()
      .min(2)
      .max(5)
      .describe("ISO 639-1 code of the target language (e.g. 'es', 'fr')."),
    sourceLanguage: z
      .string()
      .min(2)
      .max(5)
      .optional()
      .describe(
        "ISO 639-1 code of the source language. Auto-detected if omitted.",
      ),
  }),

  outputSchema: z.object({
    translatedText: z.string().describe("The translated text."),
    sourceLanguage: z
      .string()
      .describe("ISO 639-1 code of the source language."),
    targetLanguage: z
      .string()
      .describe("ISO 639-1 code of the target language."),
    sourceLanguageName: z
      .string()
      .describe("English name of the source language."),
    targetLanguageName: z
      .string()
      .describe("English name of the target language."),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "3 minutes",
    retry: {
      maximumAttempts: 2,
    },
  },
});
